import { api } from "./api";

export const activateUser = async (data: Record<string, unknown>) => {
  try {
    const url = `/user/v1/useractivate`;
    const response = await api.post(url, data);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};